import { FiservCardStatusEnum } from '@common-fe/common-fe';

import { storeCreator } from '@/utils/store/store.utils';

interface State {
  state: {
    modalVisible: boolean;
    cardholderName: string;
    cardholderID: string;
    cardID: string;
    mailedDate?: Date | null;
    activationDate?: Date | null;
    cardStatus?: FiservCardStatusEnum;
  };
  handleChangeVisibility: (value: boolean) => void;
  handleChangeCardHolderName: (cardholderName: string) => void;
  handleChangeCardHolderID: (cardholderID: string) => void;
  handleChangeMailedDate: (mailedDate: Date | null) => void;
  handleChangeActivationDate: (mailedDate: Date | null) => void;
  handleChangeCardStatus: (cardStatus?: FiservCardStatusEnum) => void;
  handleChangeCardID: (cardID: string) => void;
  handleReset: () => void;
}

export const useStore = storeCreator<State>((set) => ({
  state: {
    modalVisible: false,
    cardholderName: '',
    cardholderID: '',
    cardID: '',
    cardStatus: undefined,
    mailedDate: undefined,
    activationDate: undefined,
  },

  handleChangeVisibility: (value) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      modalVisible: value,
    },
  })),

  handleChangeCardHolderName: (cardholderName) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      cardholderName,
    },
  })),

  handleChangeCardStatus: (cardStatus) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      cardStatus,
    },
  })),

  handleChangeMailedDate: (mailedDate) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      mailedDate,
    },
  })),

  handleChangeActivationDate: (activationDate) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      activationDate,
    },
  })),

  handleChangeCardHolderID: (cardholderID) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      cardholderID,
    },

  })),

  handleChangeCardID: (cardID) => set((state) => ({
    ...state,
    state: {
      ...state.state,
      cardID,
    },
  })),

  handleReset: () => set((state) => ({
    ...state,
    state: {
      ...state.state,
      // cardholderName: '',
      cardholderID: '',
      cardID: '',
    },
  })),
}));
export default () => {
  const store = useStore();
  return {
    ...store,
  };
};
